import { useSeasonStore } from '@/store/useSeasonStore';
import { getCurrentSeason } from '@/utils/season';

/**
 * Saison effectivement appliquée aux requêtes : le choix explicite de
 * l'utilisateur s'il existe, sinon la saison courante calculée localement
 * (disponible immédiatement, sans attendre l'appel `/seasons`).
 */
export function useActiveSeason(): string {
  const selected = useSeasonStore((s) => s.selectedSeason);
  return selected ?? getCurrentSeason();
}
